export const ENV_NAMES = {
  LOCAL: "local",
  DEVELOPMENT: "development",
  DEV: "dev",
  STAGING: "staging",
  PRODUCTION: "production",
  PROD: "prod",
} as const;

export type AppEnvName = (typeof ENV_NAMES)[keyof typeof ENV_NAMES];

function getAdminDefaults(envName: string) {
  const env = envName.toLowerCase();
  if (env === ENV_NAMES.PRODUCTION || env === ENV_NAMES.PROD) {
    return {
      apiUrl: "https://api.akwaba.cm/api/v1",
      storefrontUrl: "https://akwaba.cm",
      shortlinkUrl: "https://akwa.ba",
    };
  }
  if (env === ENV_NAMES.STAGING) {
    return {
      apiUrl: "https://api.staging.akwaba.cm/api/v1",
      storefrontUrl: "https://staging.akwaba.cm",
      shortlinkUrl: "https://staging.akwa.ba",
    };
  }
  if (env === ENV_NAMES.DEV || env === ENV_NAMES.DEVELOPMENT) {
    return {
      apiUrl: "https://api.dev.akwaba.cm/api/v1",
      storefrontUrl: "https://dev.akwaba.cm",
      shortlinkUrl: "https://dev.akwa.ba",
    };
  }
  return {
    apiUrl: "http://localhost:3001/api/v1",
    storefrontUrl: "http://localhost:3000",
    // En local, l'API se sert elle-même : pas de domaine court à faire tourner.
    shortlinkUrl: "http://localhost:3001/api/v1/r",
  };
}

const appEnv =
  import.meta.env.VITE_APP_ENV ||
  (import.meta.env.DEV ? ENV_NAMES.LOCAL : ENV_NAMES.PROD);

const defaults = getAdminDefaults(appEnv);

export const env = {
  apiUrl: import.meta.env.VITE_API_URL || defaults.apiUrl,
  appName: import.meta.env.VITE_APP_NAME || "Akwaba Admin",
  storefrontUrl: import.meta.env.VITE_STOREFRONT_URL || defaults.storefrontUrl,
  // Base des liens courts. Sert uniquement à l'affichage : c'est l'API qui fait
  // foi (`shortUrl` et `smsForm` sont calculés côté serveur), pour qu'une
  // divergence de configuration ne fasse jamais copier un lien qui ne marche pas.
  shortlinkUrl: import.meta.env.VITE_SHORTLINK_URL || defaults.shortlinkUrl,
  appEnv,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  // Analytics d'usage interne. Vide = PostHog inerte (développement local).
  // Vite inline ces valeurs au build : elles sont passées en `--build-arg` par
  // le pipeline Jenkins, comme VITE_API_URL, et diffèrent donc par branche.
  posthogKey: import.meta.env.VITE_POSTHOG_KEY || "",
  // Relais de même origine, servi par le bloc `/ingest/` du nginx : appelée
  // directement, l'instance auto-hébergée ne renvoie aucun en-tête CORS et le
  // navigateur bloque chaque requête, en inscrivant une erreur par page.
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || "/ingest",
} as const;
